import React from "react";

const NewFooter = () => {
  return <div className="footer">© 2023 SuiteAmerica</div>;
};

export default NewFooter;
